"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicePeriodUpdate = exports.ServicePeriodCreate = exports.ServicePeriodQuery = exports.ServicePeriodTransport = exports.ServicePeriod = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
exports.ServicePeriod = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    billingActive: typebox_1.Type.Boolean(),
    serviceActive: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.ServicePeriodTransport = exports.ServicePeriod;
exports.ServicePeriodQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
        startsBefore: typebox_1.Type.String({ format: 'date' }),
        startsAfter: typebox_1.Type.String({ format: 'date' }),
        endsBefore: typebox_1.Type.String({ format: 'date' }),
        endsAfter: typebox_1.Type.String({ format: 'date' }),
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.ServicePeriodCreate = typebox_1.Type.Omit(exports.ServicePeriod, ['id', 'haulerID', 'customerID', 'metadata']);
exports.ServicePeriodUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServicePeriod, ['id', 'haulerID', 'customerID', 'subscriptionID', 'endDate', 'metadata']),
    typebox_1.Type.Object({ endDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date' })) }),
]));
//# sourceMappingURL=ServicePeriod.js.map